import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { I18n } from '@aws-amplify/core';
import { Button, Col, Row } from 'antd';

import { useLibertyMutualContext } from '../context';
import { PreviousCol } from './styles';

interface FooterProps {
	currentStep: number;
	onStepChange(step: number): void;
}

export const Footer: React.FC<FooterProps> = ({ onStepChange, currentStep }) => {
	const history = useHistory();
	const { steps, gettingReport, libertyMutual } = useLibertyMutualContext();
	const { search } = useLocation();
	const searchParams = new URLSearchParams(search);

	function handleNextStep() {
		onStepChange(currentStep + 1);
	}

	function handlePreviousStep() {
		onStepChange(currentStep - 1);
	}

	function redirectToReports() {
		const custom_report = !!searchParams.get('custom_report');
		if (custom_report) {
			return history.push('/custom-reports/files');
		}
		history.push('/reporting');
	}

	const disabledFinishButton =
		gettingReport ||
		libertyMutual?.reports?.length === 0 ||
		libertyMutual?.reports?.some((report) => report?.sub_step < 2);

	if (currentStep === steps.length - 1) {
		return (
			<Row>
				<Col xs={24} style={{ marginTop: '2rem' }}>
					<Row justify="center" align="middle" gutter={[0, 8]}>
						<PreviousCol>
							<Button loading={gettingReport} type="default" onClick={handlePreviousStep}>
								{I18n.get('Previous')}
							</Button>
						</PreviousCol>
						<Col>
							<Button
								loading={gettingReport}
								disabled={gettingReport}
								type="primary"
								onClick={redirectToReports}
							>
								{I18n.get('Close')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	if (currentStep > 0) {
		return (
			<Row>
				<Col xs={24} style={{ marginTop: '2rem' }}>
					<Row justify="center" align="middle" gutter={[0, 8]}>
						<PreviousCol>
							<Button loading={gettingReport} type="default" onClick={handlePreviousStep}>
								{I18n.get('Previous')}
							</Button>
						</PreviousCol>
						<Col>
							<Button
								type="primary"
								htmlType="submit"
								loading={gettingReport}
								disabled={disabledFinishButton}
								onClick={handleNextStep}
							>
								{I18n.get('Finish')}
							</Button>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	return (
		<Row>
			<Col xs={24} style={{ marginTop: '2rem' }}>
				<Row justify="center">
					<Col>
						<Button htmlType="submit" loading={gettingReport} type="primary" onClick={handleNextStep}>
							{I18n.get('Next')}
						</Button>
					</Col>
				</Row>
			</Col>
		</Row>
	);
};
